import { FIELD_WIDTH } from '@fox/atoms/contracts/field';
import { Icon } from '@fox/atoms/src/icon/index';
import { Select } from '@fox/atoms/src/select/index';
import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import Box from '@mui/material/Box';
import { ColumnFilter } from './filter-popover';
import type { FilterConditionItemProps } from './types';

export function FilterField({
	filter,
	index,
	availableColumns,
	filterOperatorsExt,
	appliedFilters,
	setAppliedFilters
}: Pick<FilterConditionItemProps, 'filter' | 'index' | 'filterOperatorsExt' | 'appliedFilters' | 'setAppliedFilters'> & {
	availableColumns: ColumnFilter[];
}) {
	function onColumnChange(e: string, i: number, col: ColumnFilter[]) {
		const filteredColumn = col.find(c => c.dataIndex === e);

		if (filteredColumn && filteredColumn.filterType) {
			const list = [...appliedFilters];
			list[i].dataIndex = e;
			list[i].filterType = filteredColumn.filterType;
			const supportedOps = filterOperatorsExt(list[i].filterType)?.filterConstraints ?? [];
			if (supportedOps.length > 0) {
				// Default to first operator if not set, or current op is not supported (due to change of property
				// to a different filter type)
				if (strIsNullOrEmpty(list[i].constrT) || !supportedOps.includes(list[i].constrT)) {
					list[i].constrT = supportedOps[0];
				}
			}

			list[i].constV = '';
			setAppliedFilters(list);
		}
	}

	const options = availableColumns.filter(o => o.filterType);
	const emptyFilter = strIsNullOrEmpty(filter.dataIndex);

	return (
		<Select<ColumnFilter, false, false, false>
			style={{ width: FIELD_WIDTH }}
			options={options}
			size="small"
			value={options.find(o => o.dataIndex === filter.dataIndex) ?? null}
			title="Pick a column"
			onChange={(_, v) => onColumnChange(v?.dataIndex, index, availableColumns)}
			startAdornment={!emptyFilter ? <Icon iconName={filterOperatorsExt(filter.filterType)?.icon ?? 'ShortText'} /> : undefined}
			renderOption={(p, o) => {
				// Remove key from props before spreading to avoid React warning
				const { key: _, ...propsWithoutKey } = p as typeof p & { key?: unknown };
				return (
					<Box key={o.dataIndex} component="li" sx={{ '& > svg': { mr: 2, flexShrink: 0 } }} {...propsWithoutKey}>
						<Icon iconName={filterOperatorsExt(o?.filterType)?.icon ?? 'ShortText'} />
						{o?.title}
					</Box>
				);
			}}
			getOptionLabel={o => `${o.title}`}
		/>
	);
}
